import { useContext, useEffect, useRef, useState } from "react";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { API } from "../../Axios/Axios";
import {
  deleteEmployeeDeclarationDetails,
  getCategoryForDeclaration,
  getSectionForDeclaration,
  insertUpdateEmployeeDeclarations,
  visibilityOfPreviousEmployerSalaryTab,
} from "../../Helpers/APIEndpoints/Endpoints";
import { LoaderContext } from "../../Helpers/Context/Context";
import {
  UnorderedListOutlined,
  PlusOutlined,
  MinusOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { FormInput } from "../../Components/FormInputs/FormInputs";
import type { CollapseProps } from "antd";
import {
  Tabs,
  Card,
  Row,
  Col,
  Button,
  Select,
  Dropdown,
  Menu,
  Form,
  InputNumber,
  Collapse,
  Checkbox,
  Radio,
  message,
  Input,
  Divider,
  Modal
} from "antd";

import { Category } from "@mui/icons-material";
import FormTable from "../../Components/DynamicTable/FormTable";
import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";

const { TabPane } = Tabs;

type ExpandIconPosition = "start" | "end";

const Declarations = ({stateUserId,IsLocked }: any) => {
  const [form] = Form.useForm();
  const { showLoader, hideLoader } = useContext(LoaderContext);
 // const { userId, currentFinancialYearId } = useAuthStore();
 console.log('stateUserId',stateUserId);
  const { userId: authUserId, currentFinancialYearId } = useAuthStore();
  console.log('autUserId',authUserId);
  const userId = stateUserId != null ? stateUserId : authUserId;
  console.log('userid is in declaration',userId)
  
  const [categories, setCategories] = useState<any[]>([]);
  const [currentCategoryId, setCurrentCategoryId] = useState(0);
  const [sections, setSections] = useState<any[]>([]);
  const [updatedSections, setUpdatedSections] = useState<any[]>([]);
  const [updatedAdditionalFields, setUpdatedAdditionalFields] = useState<any[]>([]);
  const [expandIconPosition] = useState<ExpandIconPosition>("end");
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  const [activeTabKey, setActiveTabKey] = useState("0");
  const [isLastTab, setIsLastTab] = useState(false);
  const [formInstances, setFormInstances] = useState<any[]>([]);
  const formRef = useRef<any[]>([]);
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  const [empDeclarationId, setEmpDeclarationId] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [collapsibleItems, setCollapsibleItems] = useState<any[]>([]);

  const [totalIncomeLossHP, setTotalIncomeLossHP] = useState(0);

  const [changedSectionId, setChangedSectionId] = useState(0);
  const [changedEmpDeclarationDetailsId, setChangedEmpDeclarationDetailsId] = useState(0);
  const [changedFieldName, setChangedFieldName] = useState("");
  const [changedCount, setChangedCount] = useState(0);
  const [incomeLossFieldColumnName, setIncomeLossFieldColumnName] = useState("");

  const [letPropertyValues, setLetPropertyValues] = useState<any[]>([]);
  const { confirm } = Modal;


  //get category by fin year id =  currentFinancialYearId ,  typeid = declaration,
  //get section by category, regime
  //if components exists in section , then get components by section
  //else get fields from additional field

  useEffect(() => {
    getCategory();
    console.log("categories", categories);
  }, [userId]);

  useEffect(() => {
    if (currentCategoryId > 0) {
      getSectionDataByCategory(currentCategoryId);
    }
  }, [userId,currentCategoryId]);

  const getCategory = async () => {
    try {
      showLoader();

      //debugger;

      let response = await API.post(getCategoryForDeclaration, {
        FinancialYearId: currentFinancialYearId,
        UserId: userId ? userId : 0,
      });

      if (response.data && response.data.data) {
        let PreviousEmpSalVisible = await API.post(visibilityOfPreviousEmployerSalaryTab, {
          UserId:userId,
          FinancialYearId: currentFinancialYearId,
        });

        let UpdatedCategoryForDeclaration = PreviousEmpSalVisible?.data?.data?.[0].isPreviousEmployeeSalaryVisible ? response?.data?.data?.categoryList : response?.data?.data?.categoryList?.filter((category)=> category?.Id !== 2 || category?.label !== "Previous Employer Salary")
        
        setCategories(UpdatedCategoryForDeclaration || response.data.data.categoryList);

        setCurrentCategoryId(UpdatedCategoryForDeclaration[0]?.value || response.data.data.categoryList[0].value);
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      //message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  useEffect(()=>{
    if(categories.length > 0)
    {
      if(categories.length == 1)
      {
        setIsLastTab(true);
      }
    }
  },[categories])

  const getSectionDataByCategory = async (categoryId: any) => {
    try {
      showLoader();

      //debugger;

      let response = await API.post(getSectionForDeclaration, {
        FinancialYearId: currentFinancialYearId,
        UserId: userId ? userId : 0,
        CategoryId: categoryId,
      });

      if (response.data && response.data.data) {
        setEmpDeclarationId(response.data.data.employeeDeclarationId || 0);
        //setIsSubmitted(response.data.data.isSubmitted);
        setSections(response.data.data.sectionList);
        setUpdatedSections(response.data.data.sectionList);
        setUpdatedAdditionalFields([]);
        //handleSections(response.data.data.sectionList);
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      //message.error(`Failed to perform getDropdowns`);
    } finally {
      hideLoader();
    }
  };

  const onChange = (checkedValues: any) => {
    setSelectedValues(checkedValues);
  };

  const handleFieldChange = (
    value: any,
    sectionId: any,
    field: any,
    employeeDeclarationDetailsId: any,
    count: any,
    fieldName: any
  ) => {
    //debugger;
    if (Array.isArray(value)) {
      value = value.join(",");
    }

    // Create a copy of the updatedAdditionalFields array
    setUpdatedAdditionalFields((prevState) => {
      // Check if the field already exists
      const fieldIndex = prevState.findIndex(
        (item) =>
          item.sectionId === sectionId &&
          item.field === field &&
          item.count === count
      );

      // If the field exists, update its value
      if (fieldIndex !== -1) {
        const updatedFields = [...prevState];
        updatedFields[fieldIndex] = {
          employeeDeclarationDetailsId,
          sectionId,
          field,
          value,
          count,
          fieldName
        };
        return updatedFields;
      } else {
        // If the field does not exist, add a new item
        return [
          ...prevState,
          { employeeDeclarationDetailsId, sectionId, field, value, count, fieldName },
        ];
      }
    });

    if (fieldName?.toLocaleLowerCase().includes("is it a let property?")) {

      setLetPropertyValues((prevValues) => {
        const updatedValues = [...prevValues];
        const existingIndex = updatedValues.findIndex(
          (entry) => entry.count === count
        );

        let newValue;
        if (value?.toLocaleLowerCase() == "yes") {
          newValue = {
            count: count,
            fieldColumnName: field,
            fieldName: fieldName,
            value: value,
            renderNumeric: true,
          };
        }
        else {
          newValue = {
            count: count,
            fieldColumnName: field,
            fieldName: fieldName,
            value: value,
            renderNumeric: false,
          };
        }

        if (existingIndex !== -1) {
          updatedValues[existingIndex] = newValue;
        } else {
          updatedValues.push(newValue);
        }

        return updatedValues;
      });

      // if (value?.toLocaleLowerCase() == "no") {
      //   let additionalFields;
      //   sections.forEach((item) => {
      //     if (item?.systemName?.toLowerCase()?.trim() === "housingloaninterest_sectionmaster") {
      //       additionalFields = item.additionalFieldList?.filter((x: any) =>
      //         x.count === count
      //       );
      //     }
      //   });
      //   var incomeFromHPObj = additionalFields.find(x => x.fieldName?.toLocaleLowerCase().includes("income from hp/notional rent"));
      //   var incomeFromHPFieldColumnName = incomeFromHPObj != null ? incomeFromHPObj.fieldColumnName : "";
      //   var incomeFromHPFieldName = incomeFromHPObj != null ? incomeFromHPObj.fieldName : "";

      //   var municipalTaxesPaidObj = additionalFields.find(x => x.fieldName?.toLocaleLowerCase().includes("municipal taxes paid(If any)"));
      //   var municipalTaxesPaidFieldColumnName = municipalTaxesPaidObj != null ? municipalTaxesPaidObj.fieldColumnName : "";
      //   var municipalTaxesPaidFieldName = municipalTaxesPaidObj != null ? municipalTaxesPaidObj.fieldName : "";

      //   const fieldValues: Record<string, any> = {};

      //   fieldValues[incomeFromHPFieldColumnName + count] = 0;
      //   fieldValues[municipalTaxesPaidFieldColumnName + count] = 0;

      //   form.setFieldsValue(fieldValues);

      //   handleFieldChange(0, sectionId, incomeFromHPFieldColumnName, employeeDeclarationDetailsId, count, incomeFromHPFieldName);
      //   handleFieldChange(0, sectionId, municipalTaxesPaidFieldColumnName, employeeDeclarationDetailsId, count, municipalTaxesPaidFieldName);
      // }
    }
    setChangedSectionId(sectionId);
    setChangedEmpDeclarationDetailsId(employeeDeclarationDetailsId);
    setChangedFieldName(fieldName);
    setChangedCount(count);
  };

  const handleAmountChange = (value: any, record: any, sectionId: any) => {

    setSections((prevSections) =>
      prevSections.map((section) => {
        if (section.Id !== sectionId) return section;
        const updatedComponentList = section.componentList.map(
          (component: any) =>
            component.componentId === record.componentId
              ? { ...component, amount: value, value: value }
              : component
        );
        return {
          ...section,
          componentList: updatedComponentList,
        };
      })
    );
    console.log("sections in handleAmountChange: ", sections);

    setUpdatedSections((prevSections) =>
      prevSections.map((section) => {
        if (section.Id !== sectionId) return section;

        const updatedComponentList = section.componentList.map(
          (component: any) =>
            component.componentId === record.componentId
              ? { ...component, amount: value, value: value }
              : component
        );

        return {
          ...section,
          componentList: updatedComponentList,
        };
      })
    );
  };

  const addNew = (e: any, systemName: any) => {
    //debugger;
    setSections((prevSections) =>
      prevSections.map((section) => {
        //debugger;
        if (section.systemName === systemName) {
          const lastItemCount = section.additionalFieldList.at(-1)?.count;

          const updatedFields = section.additionalFieldList.map((field) => {
            const updatedField = updatedAdditionalFields.find(
              (uf) => uf.field === field.fieldColumnName && uf.count === field.count
            );
            return updatedField ? { ...field, value: updatedField.value } : field;
          });

          const duplicatedFields = updatedFields
            .filter((field: any) => field.count === lastItemCount)
            .map((field: any) => {
              return {
                ...field,
                count: field.count + 1,
                employeeDeclarationDetailsId: 0,
                value: "",
              }
            });

          return {
            ...section,
            additionalFieldList: [
              //...section.additionalFieldList,
              ...updatedFields,
              ...duplicatedFields,
            ],
          };
        }
        return section;
      })
    );

    //debugger;
  };

  const removeFields = (e: any, systemName: any, count: any, decDetailsId: any) => {

    //var result = false;
    //result = window.confirm("Are you sure you want to remove this HP ?");

    confirm({
      content: "Are you sure you want to remove this HP ?",
      okText: 'Ok',
      cancelText: 'Cancel',
      onOk() {
        removeHP(e, systemName, count, decDetailsId);
      },
      onCancel() {
      },
    });

  };

  const removeHP = (e: any, systemName: any, count: any, decDetailsId: any) => {

    setSections((prevSections) =>
      prevSections.map((section) => {
        if (section.systemName === systemName) {
          // Before removing, optionally sync updated values into section fields
          const updatedFieldList = section.additionalFieldList.map((field) => {
            const updatedField = updatedAdditionalFields.find(
              (uf) => uf.field === field.fieldColumnName && uf.count === field.count
            );
            return updatedField ? { ...field, value: updatedField.value } : field;
          });

          // Filter out fields with the specified count
          const filteredFieldList = updatedFieldList.filter(
            (field) => field.count !== count
          );

          setUpdatedAdditionalFields((prevFields) =>
            prevFields.filter((field) => field.count !== count)
          );

          return {
            ...section,
            additionalFieldList: filteredFieldList,
          };
        }

        return section;
      })
    );

    if (decDetailsId > 0) {
      deleteDetails(decDetailsId);
    }
  }


  const deleteDetails = async (empDeclarationDetailsId: any) => {
    try {
      showLoader();
      let ExecuteActionResponse = await API.post(
        deleteEmployeeDeclarationDetails,
        {
          EmployeeDeclarationDetailsId: empDeclarationDetailsId,
        }
      );

      if (ExecuteActionResponse.data.status != 0) {
        message.error(`Failed.`);
      } else {
        message.success("Removed successfully.");
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      //message.error(`Failed to perform data save`);
    } finally {
      hideLoader();
    }
  }

  const getLastIndexByCount = (data, targetCount, index) => {
    for (let i = data.length - 1; i >= 0; i--) {
      if (data[i].count === targetCount) {
        return i;
      }
    }
    return -1; // Not found   
  };

  const getFirstIndexByCount = (data, targetCount, index) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].count === targetCount) {
        return i;
      }
    }
    return -1; // Not found
  };

  useEffect(() => {
    if (sections.length > 0) {
      console.log("Current form values:", form.getFieldsValue(true));
      console.log(
        "Form DOM is ready?",
        document.querySelectorAll("input").length
      ); // ← how many inputs exist?
      console.log(
        "Form input IDs:",
        Array.from(document.querySelectorAll("input")).map((input) => ({
          id: input.id,
          name: input.name,
        }))
      );

      const fieldValues: Record<string, any> = {};

      //debugger;

      sections.forEach((item) => {
        const sectionKey = `section_${item.Id}`;
        fieldValues[sectionKey] = {};

        // item.componentList?.forEach((citem: any) => {
        //     //fieldValues[`amount_${citem.componentId}`] = citem.value ? Number(citem.value) : 0;
        //     fieldValues[sectionKey][`amount_${citem.componentId}`] = citem.value ?? 0;
        //         //citem.value ? Number(citem.value) : 0;
        // });

        //debugger;

        item.additionalFieldList?.forEach((aitem: any) => {
          if (aitem.responseType.toLocaleLowerCase() == "choices") {
            fieldValues[aitem.fieldColumnName + aitem?.count] = aitem.value
              ? aitem.value.split(",")
              : [];
          } else {
            fieldValues[aitem.fieldColumnName + aitem?.count] =
              aitem.value ?? "";
          }
        });
      });

      console.log("Setting form values: ", fieldValues);

      form.setFieldsValue(fieldValues);
      setTotalOnLoad(sections);
      getRadioButtonPropertyOnLoad(sections);

    }
  }, [sections]);

  const setTotalOnLoad = (sections: any) => {

    setTotalIncomeLossHP(0);
    var total = 0;
    var field = "";
    if (sections.length > 0) {
      sections.forEach((item) => {
        if (item?.systemName?.toLowerCase()?.trim() === "housingloaninterest_sectionmaster") {
          item.additionalFieldList?.forEach((aitem: any) => {
            if (aitem?.fieldName?.toLocaleLowerCase().includes("income/loss from hp")) {
              total = Number(total) + Number(aitem.value);
              field = aitem?.fieldColumnName;
            }
          });
        }
      });
    }
    setTotalIncomeLossHP(total);
    setIncomeLossFieldColumnName(field);
  }

  const getRadioButtonPropertyOnLoad = (sections: any) => {
    setLetPropertyValues([]);

    var radioButtonValues: Array<any> = [];

    if (sections.length > 0) {
      sections.forEach((item) => {
        if (item?.systemName?.toLowerCase()?.trim() === "housingloaninterest_sectionmaster") {
          item.additionalFieldList?.forEach((aitem: any) => {
            if (aitem?.fieldName?.toLocaleLowerCase().includes("is it a let property?")) {
              if (aitem?.value?.toLocaleLowerCase() == "yes") {
                radioButtonValues.push({
                  count: aitem?.count,
                  fieldColumnName: aitem?.fieldColumnName,
                  fieldName: aitem?.fieldName,
                  value: aitem?.value,
                  renderNumeric: true,
                });
              }
              else {
                radioButtonValues.push({
                  count: aitem?.count,
                  fieldColumnName: aitem?.fieldColumnName,
                  fieldName: aitem?.fieldName,
                  value: aitem?.value,
                  renderNumeric: false,
                });
              }
            }
          });
        }
      });
    }
    setLetPropertyValues(radioButtonValues);
  }

  useEffect(() => {
    console.log("letPropertyValues : ", letPropertyValues);
  }, [letPropertyValues]);

  const renderNumericFields = (item: any, sectionSystemName: any) => {

    if (sectionSystemName?.toLowerCase()?.trim() === "housingloaninterest_sectionmaster") {
      var itemCount = item.count;
      var fieldName = item.fieldName;

      if (fieldName.toLocaleLowerCase().includes("income from hp/notional rent") ||
        fieldName.toLocaleLowerCase().includes("municipal taxes paid(if any)") ||
        fieldName.toLocaleLowerCase().includes("(-)30% standard deduction")
      ) {

        var renderNumericValue = letPropertyValues.find(x => x.count === itemCount)?.renderNumeric;

        return renderNumericValue;
      }
      else {
        return true;
      }
    }
    else {
      return true;
    }
  }

  const items: CollapseProps["items"] = sections?.map(
    (section: any, sectionindex: any) => ({
      key: section.Id,
      label: section.name,
      children:
        section.componentList.length > 0 ? (
          <>
            <div key={0} className="accordCont">
              <FormTable
                columns={[
                  {
                    title: "Sr. No. ",
                    key: "SrNo",
                    render: (text: any, record: any, index: any) => index + 1,
                    //fixed: "right",
                    width: "10%",
                  },
                  {
                    title: "Component",
                    key: "Component",
                    dataIndex: "componentName",
                    //fixed: "right",
                    width: 100,
                  },
                  {
                    title: "MaxLimit",
                    key: "MaxLimit",
                    dataIndex: "componentLimit",
                    render: (text: any, record: any, index: any) => {
                      if (record.componentLimit > 0) {
                        return record.componentLimit;
                      } else {
                        return "";
                      }
                    },
                    //fixed: "right",
                    width: 100,
                  },
                  {
                    title: "Amount",
                    key: "amount",
                    //dataIndex: "amount",
                    width: 100,
                    render: (text: any, record: any, index: any) => (
                      <Form.Item
                        rules={[
                          { required: true, message: "Please enter amount" },
                          // ...(item?.responseType?.toLowerCase() === "numeric" ? 
                          // [{type: "number" as "number",message: `${item?.displayName} must be a number`,} as Rule,]: []),
                        ]}

                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          placeholder="Enter Amount"
                          min={0}
                          disabled={isSubmitted || IsLocked}
                          value={record.value || 0}
                          //max={9999999999} // optional: enforces the upper bound
                          onBlur={(e: any) => {
                            handleAmountChange(e.target.value, record, section.Id);
                          }}
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ];

                            if (allowedKeys.includes(e.key)) return;

                            // Allow digits only
                            if (/^\d$/.test(e.key)) {
                              const currentValue = e.currentTarget.value?.toString() || "";
                              const selectionStart = e.currentTarget.selectionStart;
                              const selectionEnd = e.currentTarget.selectionEnd;

                              const newLength =
                                currentValue.substring(0, selectionStart) +
                                e.key +
                                currentValue.substring(selectionEnd);

                              if (newLength.length > 10) {
                                e.preventDefault();
                              }

                              return;
    }

    // Block all other input (e.g., letters, symbols)
    e.preventDefault();
  }}
/>

                      </Form.Item>
                    ),
                    //fixed: "right",
                  },
                ]}
                dataSource={section.componentList}
                pagination={false}
              />
            </div>
          </>
        ) : section.additionalFieldList.length > 0 ? (
          <>
            <div key={1} className="accordCont">

              {section?.systemName?.toLowerCase()?.trim() ===
                "housingloaninterest_sectionmaster" && (
                  <Row gutter={[24, 16]} className="p-0">
                    <Col lg={8} sm={8} md={8}>
                      <Form.Item
                        label={"Income/Loss from all the House Properties"}
                        // name={"IncomeLoss"}                        
                        rules={
                          [
                            {
                              required: true,
                              message:
                                "Please enter House Property Details"
                            },
                          ]
                        }
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          disabled={true}
                          value={totalIncomeLossHP}
                          placeholder="Enter House Property Details"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}

              <Row gutter={[24, 16]} className="p-0">
                {section.additionalFieldList.map((item: any, index: any) => (
                  <>
                    {index ===
                      getFirstIndexByCount(
                        section?.additionalFieldList,
                        item?.count,
                        index
                      ) && (section?.systemName?.toLowerCase()?.trim() ===
                        "housingloaninterest_sectionmaster") &&
                      (index !== 0) && !isSubmitted && !IsLocked && (
                        <>
                          <Col lg={24} style={{ textAlign: 'right' }}>
                            <Button
                              className="btn-saveDraft me-3"
                              type="default"
                              onClick={(e: any) => {
                                removeFields(e, section?.systemName, item.count, item.employeeDeclarationDetailsId);
                              }}
                              icon={<CloseCircleOutlined />}
                            >
                            </Button>
                          </Col>
                        </>
                      )}

                    {item.responseType.toLocaleLowerCase() == "numeric" &&
                      renderNumericFields(item, section.systemName) && (
                        <>
                          <Col lg={8} sm={8} md={8}>
                            <Form.Item
                              label={item.fieldName}
                              name={item.fieldColumnName + item.count}
                              rules={
                                item.isMandatory
                                  ? [
                                    {
                                      required: true,
                                      message: "Please enter " + item.fieldName,
                                    },
                                  ]
                                  : []
                              }
                            >
                              <InputNumber
                                style={{ width: "100%" }}
                                min={item.minValue}
                                max={item.maxValue}
                                placeholder={"Enter " +item.fieldName}
                                onChange={(value: any) =>
                                  handleFieldChange(
                                    value,
                                    section.Id,
                                    item.fieldColumnName,
                                    item.employeeDeclarationDetailsId,
                                    item.count,
                                    item.fieldName
                                  )
                                }
                                onKeyPress={(e) => {
                                  const charCode = e.which ? e.which : e.keyCode;
                                  const char = String.fromCharCode(charCode);

                                  // Allow digits
                                  if (/^\d$/.test(char)) {
                                    return;
                                  }
                                  // // Allow only one dot
                                  // if (char === "." && !e.currentTarget.value.includes(".")) {
                                  //   return;
                                  // }
                                  // Block anything else (letters, symbols, negative sign)
                                  e.preventDefault();
                                }}
                                disabled={(isSubmitted || IsLocked) ||
                                  (item.fieldName.toLocaleLowerCase().includes("income/loss from hp") ||
                                    item.fieldName.toLocaleLowerCase().includes("(-)30% standard deduction"))}
                              />
                            </Form.Item>
                          </Col>
                        </>
                      )}
                    {item.responseType.toLocaleLowerCase() == "text input" && (
                      <>
                        <Col lg={8} sm={8} md={8}>
                          <Form.Item
                            label={item.fieldName}
                            name={item.fieldColumnName + item.count}
                            rules={[
                              ...(item.isMandatory ? [{ required: true, message: "Please enter " + item.fieldName, },] : []),
                              ...(item.regex?.toLowerCase().includes("pan") ? [{ pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, message: "Invalid PAN format", },] : []),
                              ...(item.regex?.toLowerCase().includes("aadhar") ? [{ pattern: /^\d{12}$/, message: "Invalid Aadhar number", },] : []),
                              ...(item.regex?.toLowerCase().includes("number") ? [{ pattern: /^[6-9]\d{9}$/, message: "Invalid mobile number format", },] : []),
                            ]}
                          >
                            <Input
                              style={{ width: "100%" }}
                              maxLength={item.charLimit}
                              disabled={(isSubmitted || IsLocked)}
                              placeholder={"Enter " +item.fieldName}
                              onChange={(e: any) =>
                                handleFieldChange(
                                  e.target.value,
                                  section.Id,
                                  item.fieldColumnName,
                                  item.employeeDeclarationDetailsId,
                                  item.count,
                                  item.fieldName
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                    {item.responseType.toLocaleLowerCase() == "radio button" && (
                      <>
                        <Col lg={8} sm={8} md={8}>
                          <Form.Item
                            label={item.fieldName}
                            name={item.fieldColumnName + item.count}
                            rules={
                              item.isMandatory
                                ? [
                                  {
                                    required: true,
                                    message:
                                      "Please select " + item.fieldName,
                                  },
                                ]
                                : []
                            }
                          >
                            <Radio.Group
                              options={item.choicesValues.map(
                                (choice: any) => ({
                                  label: choice,
                                  value: choice,
                                })
                              )}
                              disabled={(isSubmitted || IsLocked)}
                              onChange={(e: any) =>
                                handleFieldChange(
                                  e.target.value,
                                  section.Id,
                                  item.fieldColumnName,
                                  item.employeeDeclarationDetailsId,
                                  item.count,
                                  item.fieldName
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                    {item.responseType.toLocaleLowerCase() == "choices" && (
                      <>
                        <Col lg={8} sm={8} md={8}>
                          <Form.Item
                            label={item.fieldName}
                            name={item.fieldColumnName + item.count}
                            rules={
                              item.isMandatory
                                ? [
                                  {
                                    required: true,
                                    message:
                                      "Please select " + item.fieldName,
                                  },
                                ]
                                : []
                            }
                          >
                            <Checkbox.Group
                              options={item.choicesValues.map(
                                (choice: any) => ({
                                  label: choice,
                                  value: choice,
                                })
                              )}
                              disabled={(isSubmitted || IsLocked)}
                              onChange={(value: any) =>
                                handleFieldChange(
                                  value,
                                  section.Id,
                                  item.fieldColumnName,
                                  item.employeeDeclarationDetailsId,
                                  item.count,
                                  item.fieldName
                                )
                              }
                            ></Checkbox.Group>
                          </Form.Item>
                        </Col>
                      </>
                    )}

                    {index ===
                      getLastIndexByCount(
                        section?.additionalFieldList,
                        item?.count,
                        index
                      ) && (section?.systemName?.toLowerCase()?.trim() ===
                        "housingloaninterest_sectionmaster") && (
                        <>
                          <Divider
                            style={{
                              height: "1px",
                              border: "none",
                              margin: "32px 0",
                              background:
                                "linear-gradient(to right, rgba(61, 38, 121, 0) 0%, rgba(94, 41, 228, 0.4) 25%, rgba(99, 48, 230, 0.4) 75%, rgba(61, 38, 121, 0) 100%)",
                            }}
                          />
                        </>
                      )}
                  </>
                ))}
              </Row>

              {section?.systemName?.toLowerCase()?.trim() ===
                "housingloaninterest_sectionmaster" &&
                section?.isReplicable && !isSubmitted  && !IsLocked && (
                  <>
                    <Button
                      className="btn-viewsub me-3"
                      type="default"
                      onClick={(e: any) => {
                        addNew(e, section?.systemName);
                      }}
                    >
                      {"Add HP"}
                    </Button>
                  </>
                )}
            </div>
          </>
        ) : (
          <div></div>
        ),
    })
  );

  useEffect(() => {
    if (changedFieldName.toLocaleLowerCase().includes("is it a let property?") ||
      changedFieldName.toLocaleLowerCase().includes("income from hp/notional rent") ||
      changedFieldName.toLocaleLowerCase().includes("municipal taxes paid(if any)") ||
      changedFieldName.toLocaleLowerCase().includes("interest paid on property(upto limit of 200000)") //||
      // changedFieldName.toLocaleLowerCase().includes("(-)30% standard deduction") ||
      // changedFieldName.toLocaleLowerCase().includes("income/loss from hp")
    ) {
      calculateOnChange(changedSectionId, changedEmpDeclarationDetailsId, changedCount);
    }
  }, [updatedAdditionalFields]);

  const calculateOnChange = (
    sectionId: any,
    employeeDeclarationDetailsId: any,
    count: any
  ) => {

    var incomeFromHpNotionalRent = 0;
    var municipalTaxesPaid = 0;
    var interestPaidOnProperty = 0;
    var standardDeduction = 0;
    var incomeLossFromHp = 0;
    var sectionName = "";

    var incomeFromHpNotionalRentFieldColumnName = "";
    var municipalTaxesPaidFieldColumnName = "";
    var standardDeductionFieldColumnName = "";
    var incomeLossFromHpFieldColumnName = "";

    var incomeFromHpNotionalRentFieldName = "";
    var municipalTaxesPaidFieldName = "";
    var standardDeductionFieldName = "";  //"(-)30% Standard deduction";
    var incomeLossFromHpFieldName = "";   //"Income/Loss from HP";

    //get all the values from updatedAdditionalFields
    //if value not found in updatedAdditionalFields, find and get the existing value from additionalFields

    if (sections.length > 0) {
      sections.forEach((item) => {
        if (item?.systemName?.toLowerCase()?.trim() === "housingloaninterest_sectionmaster") {

          sectionName = "housingloaninterest_sectionmaster";

          const additionalFields = item.additionalFieldList?.filter((x: any) =>
            x.count === count
          );

          var incomeFromHpNotionalRentObj = additionalFields.find(x => x.fieldName?.toLocaleLowerCase().includes("income from hp/notional rent"));
          incomeFromHpNotionalRent = incomeFromHpNotionalRentObj != null ? Number(incomeFromHpNotionalRentObj.value) : 0;
          incomeFromHpNotionalRentFieldColumnName = incomeFromHpNotionalRentObj != null ? incomeFromHpNotionalRentObj.fieldColumnName : "";
          incomeFromHpNotionalRentFieldName = incomeFromHpNotionalRentObj != null ? incomeFromHpNotionalRentObj.fieldName : "";

          var municipalTaxesPaidObj = additionalFields.find(x => x.fieldName?.toLocaleLowerCase().includes("municipal taxes paid(if any)"));
          municipalTaxesPaid = municipalTaxesPaidObj != null ? Number(municipalTaxesPaidObj.value) : 0;
          municipalTaxesPaidFieldColumnName = municipalTaxesPaidObj != null ? municipalTaxesPaidObj.fieldColumnName : "";
          municipalTaxesPaidFieldName = municipalTaxesPaidObj != null ? municipalTaxesPaidObj.fieldName : "";

          var interestPaidOnPropertyObj = additionalFields.find(x => x.fieldName?.toLocaleLowerCase().includes("interest paid on property(upto limit of 200000)"));
          interestPaidOnProperty = interestPaidOnPropertyObj != null ? Number(interestPaidOnPropertyObj.value) : 0;

          var standardDeductionObj = additionalFields.find(x => x.fieldName?.toLocaleLowerCase().includes("(-)30% standard deduction"));
          standardDeduction = standardDeductionObj != null ? Number(standardDeductionObj.value) : 0;
          standardDeductionFieldColumnName = standardDeductionObj != null ? standardDeductionObj.fieldColumnName : "";
          standardDeductionFieldName = standardDeductionObj != null ? standardDeductionObj.fieldName : "";

          var incomeLossFromHpObj = additionalFields.find(x => x.fieldName?.toLocaleLowerCase().includes("income/loss from hp"));
          incomeLossFromHp = incomeLossFromHpObj != null ? Number(incomeLossFromHpObj.value) : 0;
          incomeLossFromHpFieldColumnName = incomeLossFromHpObj != null ? incomeLossFromHpObj.fieldColumnName : "";
          incomeLossFromHpFieldName = incomeLossFromHpObj != null ? incomeLossFromHpObj.fieldName : "";
        }
      });
    }

    if (sectionName == "housingloaninterest_sectionmaster") {

      var incomeFromHpNotionalRentUpdObj = updatedAdditionalFields.find(item => item.employeeDeclarationDetailsId === employeeDeclarationDetailsId
        && item.sectionId === sectionId && item.count === count &&
        item.fieldName.toLocaleLowerCase().includes("income from hp/notional rent"));

      incomeFromHpNotionalRent = incomeFromHpNotionalRentUpdObj != null ? Number(incomeFromHpNotionalRentUpdObj.value) : incomeFromHpNotionalRent;

      var municipalTaxesPaidUpdObj = updatedAdditionalFields.find(item => item.employeeDeclarationDetailsId === employeeDeclarationDetailsId
        && item.sectionId === sectionId && item.count === count &&
        item.fieldName.toLocaleLowerCase().includes("municipal taxes paid(if any)"));

      municipalTaxesPaid = municipalTaxesPaidUpdObj != null ? Number(municipalTaxesPaidUpdObj.value) : municipalTaxesPaid;

      var interestPaidOnPropertyUpdObj = updatedAdditionalFields.find(item => item.employeeDeclarationDetailsId === employeeDeclarationDetailsId
        && item.sectionId === sectionId && item.count === count &&
        item.fieldName.toLocaleLowerCase().includes("interest paid on property(upto limit of 200000)"));

      interestPaidOnProperty = interestPaidOnPropertyUpdObj != null ? Number(interestPaidOnPropertyUpdObj.value) : interestPaidOnProperty;

      var standardDeductionUpdObj = updatedAdditionalFields.find(item => item.employeeDeclarationDetailsId === employeeDeclarationDetailsId
        && item.sectionId === sectionId && item.count === count &&
        item.fieldName.toLocaleLowerCase().includes("(-)30% standard deduction"));

      standardDeduction = standardDeductionUpdObj != null ? Number(standardDeductionUpdObj.value) : standardDeduction;

      var incomeLossFromHpUpdObj = updatedAdditionalFields.find(item => item.employeeDeclarationDetailsId === employeeDeclarationDetailsId
        && item.sectionId === sectionId && item.count === count &&
        item.fieldName.toLocaleLowerCase().includes("income/loss from hp"));

      incomeLossFromHp = incomeLossFromHpUpdObj != null ? Number(incomeLossFromHpUpdObj.value) : incomeLossFromHp;


      var letProperty = updatedAdditionalFields.find(item => item.employeeDeclarationDetailsId === employeeDeclarationDetailsId
        && item.sectionId === sectionId && item.count === count &&
        item.fieldName.toLocaleLowerCase().includes("is it a let property?"));

      var letPropertyValue = letProperty != null ? letProperty.value : "";

      if (letPropertyValue.toLocaleLowerCase() == "no") {
        incomeFromHpNotionalRent = 0;
        municipalTaxesPaid = 0;
        standardDeduction = 0;
      }


      //Formula
      //(Income from HP/Notional rent - Municipal taxes paid(If any)) * 30/100
      standardDeduction = (Number(incomeFromHpNotionalRent) - Number(municipalTaxesPaid)) * (30 / 100)

      //(Income from HP/Notional rent - Municipal taxes paid(If any)) - (Interest paid on property(upto limit of 200000) + (-)30% Standard deduction)
      incomeLossFromHp = ((Number(incomeFromHpNotionalRent) - Number(municipalTaxesPaid)) - (Number(interestPaidOnProperty) + Number(standardDeduction)));

      // console.log("standardDeduction : " + standardDeduction);
      // console.log("incomeLossFromHp : " + incomeLossFromHp);

      const fieldValues: Record<string, any> = {};

      fieldValues[standardDeductionFieldColumnName + count] = standardDeduction;
      fieldValues[incomeLossFromHpFieldColumnName + count] = incomeLossFromHp;

      form.setFieldsValue(fieldValues);

      handleFieldChange(standardDeduction, sectionId, standardDeductionFieldColumnName,
        employeeDeclarationDetailsId, count, standardDeductionFieldName);
      handleFieldChange(incomeLossFromHp, sectionId, incomeLossFromHpFieldColumnName,
        employeeDeclarationDetailsId, count, incomeLossFromHpFieldName);


      if (letPropertyValue.toLocaleLowerCase() == "no") {
        fieldValues[incomeFromHpNotionalRentFieldColumnName + count] = incomeFromHpNotionalRent;
        fieldValues[municipalTaxesPaidFieldColumnName + count] = municipalTaxesPaid;

        form.setFieldsValue(fieldValues);

        updateFieldsInAdditional(incomeFromHpNotionalRent, sectionId, incomeFromHpNotionalRentFieldColumnName,
          employeeDeclarationDetailsId, count, incomeFromHpNotionalRentFieldName);
        updateFieldsInAdditional(municipalTaxesPaid, sectionId, municipalTaxesPaidFieldColumnName,
          employeeDeclarationDetailsId, count, municipalTaxesPaidFieldName);
      }

      const allFields = form.getFieldValue() || [];

      const incomeLossItems = Object.entries(allFields).filter(([key]) => key.startsWith(incomeLossFieldColumnName));
      console.log("incomeLossItems : ", incomeLossItems);

      const total = incomeLossItems.reduce((sum, [_, value]) => {
        const num = Number(value);
        return sum + (isNaN(num) ? 0 : num);
      }, 0);

      // let total = 0;
      // let updatedFields;
      // sections.forEach((item) => {
      //   if (item?.systemName?.toLowerCase()?.trim() === "housingloaninterest_sectionmaster") {
      //     updatedFields = item.additionalFieldList.map((field: any) => {
      //       const updatedField = updatedAdditionalFields.find(
      //         (uf) => uf.field === field.fieldColumnName && uf.count === field.count
      //       );
      //       return updatedField ? { ...field, value: updatedField.value } : field;
      //     });
      //   }
      // })

      // if (updatedFields.length > 0) {
      //   total = updatedFields
      //     ?.filter(field => field.fieldColumnName === 'Field17Bigint')
      //     .reduce((sum, field) => sum + Number(field.value || 0), 0);

      //   console.log(total);
      // }

      setTotalIncomeLossHP(total);
    }
  }

  const updateFieldsInAdditional = (
    value: any,
    sectionId: any,
    field: any,
    employeeDeclarationDetailsId: any,
    count: any,
    fieldName: any
  ) => {
    // Create a copy of the updatedAdditionalFields array
    setUpdatedAdditionalFields((prevState) => {
      // Check if the field already exists
      const fieldIndex = prevState.findIndex(
        (item) =>
          item.sectionId === sectionId &&
          item.field === field &&
          item.count === count
      );

      // If the field exists, update its value
      if (fieldIndex !== -1) {
        const updatedFields = [...prevState];
        updatedFields[fieldIndex] = {
          employeeDeclarationDetailsId,
          sectionId,
          field,
          value,
          count,
          fieldName
        };
        return updatedFields;
      } else {
        // If the field does not exist, add a new item
        return [
          ...prevState,
          { employeeDeclarationDetailsId, sectionId, field, value, count, fieldName },
        ];
      }
    });

  }

  const expandIcon = (panelProps: any) => {
    const isActive = activeKeys.includes(panelProps.key);
    return isActive ? <MinusOutlined /> : <PlusOutlined />;
  };

  const handleCollapseChange = (keys: string | string[]) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys]);
  };

  const handleSkip = (e: any) => {
    e.preventDefault();
    let nextTab = Number(activeTabKey) + 1;
    if (nextTab >= categories.length) {
      nextTab = 0;
    }

    setActiveTabKey(String(nextTab));
    setCurrentCategoryId(categories[nextTab]?.value);
    if (nextTab + 1 == categories.length) {
      setIsLastTab(true);
    } else {
      setIsLastTab(false);
    }
  };

  const handleTabClick = (key: string) => {
    setActiveTabKey(key);
    const category = categories[Number(key)];
    if (category) {
      setCurrentCategoryId(category?.value);
    }
    if (Number(key) + 1 == categories.length) {
      setIsLastTab(true);
    } else {
      setIsLastTab(false);
    }
  };

  const handleSave = async (e: any, type: any) => {
    if (type.toLocaleLowerCase() == "submit") {
      confirm({
        content: "Are you sure you want to submit ?",
        okText: 'Ok',
        cancelText: 'Cancel',
        onOk() {
          processSave(e, type);
        },
        onCancel() {
        },
      });
    }
    else {
      processSave(e, type);
    }
  }

  const processSave = async (e: any, type: any) => {
    //debugger;
    try {
      showLoader();

      var result = true;

      // if (type.toLocaleLowerCase() == "submit") {
      //   result = window.confirm("Are you sure you want to submit ?");
      // } else {
      //   result = true;
      // }

      if (result) {
        const formValues: Array<any> = [];
        const val = await form.getFieldsValue();
        const validate = await form.validateFields();

        // //validate all amount fields
        // const hasNullAmount = updatedSections.some(section =>
        //     section.componentList.some((item: any) => item.amount === null)
        // );

        // if (hasNullAmount) {
        //     message.error("Please fill all required fields.");
        //     return false;
        // }

        updatedSections.map((item: any, index: any) => {
          item.componentList.map((citem: any, cindex: any) => {
            //Commented by aniruddha as when updating back to 0 this was not saving in backend
            // if (citem.amount > 0) 
            //   {
              formValues.push({
                EmployeeDeclarationDetailsId:
                  citem.employeeDeclarationDetailsId || 0,
                SectionId: item.Id,
                ComponentId: citem.componentId,
                Value: citem.amount,
                AdditionalFields: [],
              });
            //}
          });
        });

        const grouped: {
          [key: string]: {
            EmployeeDeclarationDetailsId: number;
            SectionId: number;
            ComponentId: number;
            Value: number;
            AdditionalFields: [];
          };
        } = {};

        updatedAdditionalFields.forEach((item: any) => {
          const key = `${item.employeeDeclarationDetailsId}-${item.sectionId}`;
          if (!grouped[key]) {
            grouped[key] = {
              EmployeeDeclarationDetailsId:
                item.employeeDeclarationDetailsId || 0,
              SectionId: item.sectionId,
              ComponentId: 0,
              Value: 0,
              AdditionalFields: [],
            };
          }

          // grouped[key].AdditionalFields.push({
          //   key: item.field,
          //   value: String(item.value),
          // });
        });

        //debugger;

        const counter = [];
        let details: { key: string; value: string }[];

        const groupedByadditionField = updatedAdditionalFields.reduce(
          (acc, additionField) => {
            const key = additionField.count;
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(additionField);
            return acc;
          },
          {} as Record<string, any[]>
        );

        Object.values(groupedByadditionField).forEach((env: any) => {
          details = env.map((item) => ({
            key: item.field,
            value: String(item.value),
          }));

          counter.push(JSON.stringify(details));
        });

        //debugger;

        Object.entries(grouped).forEach(([sectionId, item]) => {
          // if (item.AdditionalFields.length > 0) {
          formValues.push({
            EmployeeDeclarationDetailsId:
              item.EmployeeDeclarationDetailsId ?? 0, // or use actual value
            SectionId: item.SectionId,
            ComponentId: 0,
            Value: 0,
            // AdditionalFields: JSON.stringify(item.AdditionalFields),
            AdditionalFields: counter,
          });
          // }
        });

        let ExecuteActionResponse = await API.post(
          insertUpdateEmployeeDeclarations,
          {
            EmployeeDeclarationId: empDeclarationId,
            FinancialYearId: currentFinancialYearId,
            UserId: userId,
            CategoryId: currentCategoryId,
            SectionCount: sections.length,
            ActionType: type,
            CreatedBy: userId,
            DetailsList: formValues,
          }
        );

        //debugger;

        if (ExecuteActionResponse.data.status != 0) {
          message.error(`Failed.`);
        } else {
          if (type.toLocaleLowerCase() == "save") {
            message.success("Form saved successfully.");
            handleSkip(e);
          } else if (type.toLocaleLowerCase() == "submit") {
            message.success("Form submitted successfully.");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      //message.error(`Failed to perform data save`);
    } finally {
      hideLoader();
    }
  };

  return (
    <>
      <div>
        <Card className="tabsEmpl">
          <Tabs
            type="card"
            tabPosition="top"
            defaultActiveKey={"0"}
            activeKey={activeTabKey}
            onTabClick={handleTabClick}
          >
            {categories.map((item: any, index) => (
              <TabPane
                tab={
                  <span>
                    <UnorderedListOutlined style={{ fontSize: "0.9em" }} />
                    {/* <a onClick={(e: any) => 
                                            setCurrentCategoryId(item.value)}>{item.label}</a> */}
                    {item.label}
                  </span>
                }
                key={index}
              ></TabPane>
            ))}
          </Tabs>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={6} md={12} lg={24}>
              <Form layout="vertical" className="tabform" form={form}>
                <Card className="cardby">
                  <div className="accordianDetail">
                    <Collapse
                      defaultActiveKey={items.map((item: any) => item.key)}
                      // onChange={onChange}
                      expandIconPosition={expandIconPosition}
                      items={items}
                      expandIcon={() => null}
                      activeKey={items.map((item: any) => item.key)}
                      onChange={handleCollapseChange}
                    />
                  </div>
                  <div className="savBtns d-flex justify-content-end mt-3 gap-2">
                    {!isLastTab && !isSubmitted && !IsLocked && (
                      <Button
                        className="btn-cancel"
                        type="default"
                        onClick={(e: any) => handleSkip(e)}
                      >
                        Skip
                      </Button>
                    )}
                    {!isLastTab && !isSubmitted && !IsLocked && (
                      <Button
                        className="btn-submit"
                        type="default"
                        onClick={(e: any) => handleSave(e, "Save")}
                      >
                        Save & Next
                      </Button>
                    )}
                    {isLastTab && !isSubmitted && !IsLocked && (
                      <Button
                        className="btn-saveDraft"
                        type="default"
                        onClick={(e: any) => handleSave(e, "Save")}
                      >
                        Save as draft
                      </Button>
                    )}
                    {isLastTab && !isSubmitted && !IsLocked && (
                      <Button
                        className="btn-submit"
                        type="default"
                        onClick={(e: any) => handleSave(e, "Submit")}
                      >
                        Submit
                      </Button>
                    )}
                    {/* <Button className="btn-viewsub" type="default"
                                            onClick={(e: any) => Test(e)}>
                                            Test
                                        </Button> */}
                  </div>
                </Card>
              </Form>
            </Col>
          </Row>
        </Card>
      </div>
    </>
  );
};

export default Declarations;
